module.exports = __webpack_public_path__ + "static_portal/img/share.1bcbfb42.jpg";